import {
  MUTATION_ADD_TO_BASKET,
  MUTATION_REMOVE_FROM_BASKET,
  MUTATION_RESET_BASKET,
  MUTATION_SET_QUANTITY_FOR_PRODUCT
} from './mutation-types';

const getProductInBasket = (state, product) =>
  state.items.find(
    basketProduct => basketProduct.articleNumber === product.articleNumber
  );
const cleanUpBasket = state => {
  const positions = [];
  state.items.forEach((product, idx) => {
    if (product.quantity === 0) {
      positions.push(idx);
    }
  });
  positions.forEach(position => state.items.splice(position, 1));
};

export default {
  [MUTATION_ADD_TO_BASKET]: (state, product) => {
    const basketProduct = getProductInBasket(state, product);
    if (!basketProduct) {
      state.items.push({ ...product, quantity: 1 });
    } else {
      basketProduct.quantity++;
    }
  },
  [MUTATION_REMOVE_FROM_BASKET]: (state, product) => {
    const basketProduct = getProductInBasket(state, product);
    if (!basketProduct) {
      return;
    }
    basketProduct.quantity--;
    cleanUpBasket(state);
  },
  [MUTATION_SET_QUANTITY_FOR_PRODUCT](state, [product, newQuantity]) {
    const basketProduct = getProductInBasket(state, product);
    const quantity = parseInt(newQuantity, 10);
    if (basketProduct) {
      basketProduct.quantity = quantity;
    } else {
      state.items.push({ ...product, quantity: quantity });
    }
    cleanUpBasket(state);
  },
  [MUTATION_RESET_BASKET]: state => {
    state.items = [];
  }
};
